module.exports = __webpack_public_path__ + "media/images/lp/lp11-f24e9da960d88c1ad402483b7476b0ab.webp";